import { OTP } from 'config/api-routes';
import { POST } from 'utils/request';
import { formatResponse } from 'utils/service-helpers';

export default class OtpService {
  async sendCode(data: { phoneNumber: string }, opts = {}) {
    const response = await POST(OTP.SEND.POST(), data, opts);

    return formatResponse(response);
  }

  async verifyCode(data: { phoneNumber: string; code: string; savePhone?: boolean; previousCode?: string }, opts = {}) {
    const response = await POST(OTP.VERIFY.POST(), data, opts);

    return formatResponse(response);
  }
}
